import React from "react";
import { EaseDrawer } from "../../../libs/EaseDrawer";
import { Text1 } from "../../../styles";
import { Descriptions, Button, Icon } from "antd";
import './index.scss';


const UserDetailsDrawer = (props) => {
    const { user } = props;

    const renderTitle = () => {
        return (
            <div className="mb-4">
                <Text1 className="d-block" strong>User Details</Text1>
            </div>
        )
    };

    const renderBasicDetails = () => {
        return (
            <Descriptions className="mb-4" column={1} size="small" bordered>
                <Descriptions.Item label="User Name">{user.name || "---"}</Descriptions.Item>
                <Descriptions.Item label="Email ID">{user.email || "---"}</Descriptions.Item>
                <Descriptions.Item label="Phone">{user.phone || "---"}</Descriptions.Item>
            </Descriptions>
        )
    };


    return (
        <EaseDrawer
            className="user-details-wrapper"
            title={false}
            width={450}
            visible={props.visible}
            onClose={props.toggleDetailsDrawer}
            centered
            hideHeader
            hideFooter
            destroyOnClose
        >
            <div className="mt-3">
                {renderTitle()}
                {renderBasicDetails()}
            </div>
        </EaseDrawer>
    )
};

export { UserDetailsDrawer };